export default (theme) => ({
  addressLink: {
    "&:hover": {
      cursor: "pointer",
      color: theme.secondaryColor,
      textDecoration: "underline",
    },
    "&:active": { opacity: "0.8" },
  },
  contactBtn: {
    backgroundColor: "transparent",
    border: "0",
    width: "fit-content",
    display: "flex",
    fontSize: "14px",
    cursor: "unset",
    svg: { marginRight: "5px" },
  },
  buttonResponse: {
    backgroundColor: theme.secondaryColor,
    "&:hover": {
      backgroundColor: "var(--main-color-palette)",
      cursor: "pointer",
    },
    "&:active": { backgroundColor: theme.secondaryColor },
  },
});
